import { api } from "./client";
import type { PagedQuery, PagedResult } from "@/types/api";
import type { BrokerTaskDto, BrokerTaskStatus, BrokerTaskType, TaskPriority } from "./leads";

export interface BrokerTaskListQuery extends PagedQuery {
  status?: BrokerTaskStatus;
  assignedTo?: string;
  todayOnly?: boolean;
  overdueOnly?: boolean;
  brokerLeadId?: string;
  brokerId?: string;
}

export interface UpsertBrokerTaskPayload {
  title: string;
  description?: string;
  dueDate: string;
  reminderDate?: string;
  priority: TaskPriority;
  taskType: BrokerTaskType;
  assignedToUserId?: string;
}

export const tasksApi = {
  list: (query?: BrokerTaskListQuery) =>
    api.get<PagedResult<BrokerTaskDto>>("/tasks", query),
  today: () => api.get<BrokerTaskDto[]>("/tasks/today"),
  get: (id: string) => api.get<BrokerTaskDto>(`/tasks/${id}`),
  update: (id: string, body: UpsertBrokerTaskPayload) =>
    api.put<BrokerTaskDto>(`/tasks/${id}`, body),
  complete: (id: string, completedNotes?: string) =>
    // Send `null` rather than dropping the key — defensive against
    // System.Text.Json's RespectRequiredConstructorParameters semantics.
    api.patch<BrokerTaskDto>(`/tasks/${id}/complete`, {
      completedNotes: completedNotes ?? null,
    }),
  delete: (id: string) => api.delete<void>(`/tasks/${id}`),
};
